import type { ExpenseManagementRouteName } from '@/shared/common/types/expenseManagementRoutes.type';

/**
 * Vive en `shared/` porque `shared/layouts` (menú lateral) navega a estas rutas y
 * `shared/` no puede importar de `modules/`.
 */
export const EXPENSE_MANAGEMENT_ROUTE_NAMES = {
  HOME: 'expense-management',
  SUBMITTER: 'expense-management-submitter',
  APPROVER: 'expense-management-approver',
  ADMINISTRATOR: 'expense-management-administrator',
  POLICIES: 'expense-management-policies',
} as const;

export const EXPENSE_MANAGEMENT_ROUTE_PATHS = {
  [EXPENSE_MANAGEMENT_ROUTE_NAMES.HOME]: '/expense-management',
  [EXPENSE_MANAGEMENT_ROUTE_NAMES.SUBMITTER]: '/expense-management/submitter',
  [EXPENSE_MANAGEMENT_ROUTE_NAMES.APPROVER]: '/expense-management/approver',
  [EXPENSE_MANAGEMENT_ROUTE_NAMES.ADMINISTRATOR]: '/expense-management/administrator',
  [EXPENSE_MANAGEMENT_ROUTE_NAMES.POLICIES]: '/expense-management/administrator/policies',
} as const satisfies Record<ExpenseManagementRouteName, string>;
